export function handleAwsError(error) {
    if (!error) return 'An unknown error occurred.';
  
    const { name, message, code } = error;
  
    // Common AWS Cognito/Auth Errors
    switch (name || code) {
      case 'UsernameExistsException':
        return 'An account with this username already exists.';
      case 'UserNotFoundException':
        return 'User does not exist.';
      case 'NotAuthorizedException':
        return 'Incorrect username or password.';
      case 'InvalidPasswordException':
        return 'Password does not meet complexity requirements.';
      case 'CodeMismatchException':
        return 'The confirmation code is incorrect.';
      case 'ExpiredCodeException':
        return 'The confirmation code has expired.';
      case 'LimitExceededException':
        return 'Attempt limit exceeded, please try again later.';
      case 'TooManyRequestsException':
        return 'Too many requests. Please wait and try again.';
      case 'UserNotConfirmedException':
        return 'User account is not confirmed.';
      case 'NetworkError':
        return 'Network error. Please check your connection.';
      case 'AliasExistsException':
        return 'An account with this email or phone number already exists.';
      case 'InvalidParameterException':
        return 'Invalid parameters provided.';
      case 'ResourceNotFoundException':
        return 'Requested resource was not found.';
      case 'InternalErrorException':
        return 'Internal server error. Please try again later.';
      case 'ServiceError':
        return 'Service is currently unavailable. Please try again.';
      default:
        return message || 'An unknown AWS error occurred.';
    }
  }
  